import { render, staticRenderFns } from "./ProcessHandoffModal.vue?vue&type=template&id=76fa539a&scoped=true"
import script from "./ProcessHandoffModal.vue?vue&type=script&lang=js"
export * from "./ProcessHandoffModal.vue?vue&type=script&lang=js"
import style0 from "./ProcessHandoffModal.vue?vue&type=style&index=0&id=76fa539a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fa539a",
  null
  
)

export default component.exports